import { Button, Typography, TextField, InputAdornment, Tooltip } from '@material-ui/core';
import Popover from '@mui/material/Popover';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import React, { useState, useEffect } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { GET_ALL_STORE, STORE_SWITCH } from '../../config/api';
import { clearApiDataAction, fetchGetApiData } from '../../redux/action';
import defaultStoreGrey from '../../assets/images/defaultstoresidebar_grey.svg';
import arrowupDown from '../../assets/images/arrowupdown.svg';
import http from '../../config/http';
import { devLog, isDevelopment, setStoreForLocal, _can, _route } from '../../utils';
import AvatarStore from '../growz/AvatarStore';
import { PERM_STORES_ADD_NEW, PERM_STORES_PAGE_VIEW } from '../../config/permissions';
import { toLower } from 'lodash';

function StoreSwitcher({ realm }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const [anchorEl, setAnchorEl] = useState(null);
  const [search, setSearch] = useState('');
  const allStoresList = useSelector(({ page }) => page.getAllStoresListApi?.data || []);
  const store = useSelector(({ auth }) => auth.store);
  let stores = allStoresList.filter((i) => i._id !== store._id && i.status === 'active');
  if (search.length > 0) {
    stores = stores.filter((i) => toLower(i.name).includes(toLower(search)));
  }

  useEffect(() => {
    dispatch(
      fetchGetApiData({
        url: GET_ALL_STORE,
        key: 'getAllStoresListApi',
      }),
    );
    return () => {
      dispatch(clearApiDataAction('getAllStoresListApi'));
    };
  }, []);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const handelOnClick = async (storeId) => {
    try {
      await http.post(STORE_SWITCH, { storeId, app: realm });
      !isDevelopment() || setStoreForLocal(storeId);
      history.push(_route(realm));
      window.localStorage.removeItem('sg-date-global');
      window.location.reload();
    } catch (e) {
      devLog(e);
    }
  };

  const getStoreStatus = (active) => {
    if (active) {
      return 'Active';
    }
    return 'In progress';
  };

  return (
    <>
      <div>
        <Button className="storelistButton" onClick={handleClick}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <AvatarStore logo={store.logo} showFlag />
            <div className="sidebarSingle_store">
              <Tooltip title={store.name} arrow>
                <div className="sidebarSingle_store_title">{store.name}</div>
              </Tooltip>
              <div className="sidebarSingle_store_smtitle">Store view</div>
            </div>
          </div>
          <div className="sidebarSingle_store_icon">
            <img src={arrowupDown} />
          </div>
        </Button>
      </div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        className="storelist_popup"
      >
        <div
          className="cardShadowPopupsDark"
          style={{ width: '280px', borderRadius: '10px', maxHeight: '500px', overflow: 'hidden' }}
        >
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Typography
                variant="body2"
                style={{
                  fontSize: '14px',
                  lineHeight: '24px',
                  fontWeight: 500,
                  display: 'inline-flex',
                  justifyContent: 'space-between',
                }}
              >
                Switch Stores
              </Typography>
              {_can(PERM_STORES_PAGE_VIEW) && (
                <Link to="/stores">
                  <Typography
                    variant="body2"
                    style={{
                      color: '#fff',
                      fontWeight: 500,
                      fontSize: '14px',
                      lineHeight: '24px',
                      cursor: 'pointer',
                      textDecoration: 'underline',
                    }}
                  >
                    View All
                  </Typography>
                </Link>
              )}
            </div>

            {/* {stores?.length > 0 && ( */}
            <div>
              <TextField
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon style={{ color: 'rgb(255 255 255 / 50%)' }} />
                    </InputAdornment>
                  ),
                }}
                onChange={(e) => setSearch(e.target.value)}
                style={{
                  background: '#101828',
                  fontSize: '13px',
                  color: '#fff',
                  width: '100%',
                  margin: '1rem 0 1.5rem 0',
                  borderRadius: '6px',
                  border: '1px solid rgb(255 255 255 / 40%)',
                }}
                variant="outlined"
                placeholder="Search by store name..."
                size="small"
                className="textColor"
              />
            </div>
            {/* )} */}

            {stores.length > 0 ? (
              <div
                className="customScrollbarDark"
                style={{ maxHeight: '250px', overflowY: 'auto', overflowX: 'hidden', paddingRight: '10px' }}
              >
                {stores?.map((item) => (
                  <Button
                    className="storelistButton_popup"
                    style={{ margin: '1rem 0' }}
                    key={item._id}
                    onClick={() => handelOnClick(item._id)}
                  >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <AvatarStore logo={item?.logo} />
                      <div className="sidebarSingle_store">
                        <Tooltip title={item.name} arrow>
                          <div className="sidebarSingle_store_title" style={{ width: '130px' }}>
                            {item.name}
                          </div>
                        </Tooltip>
                        <div className="sidebarSingle_store_smtitle">
                          {getStoreStatus(item?.onboardingDone)} &#183; Region {item?.countryCode}
                        </div>
                      </div>
                    </div>
                    <div className="sidebarSingle_store_icon">
                      <ChevronRightIcon style={{ opacity: '0.7' }} />
                    </div>
                  </Button>
                ))}
              </div>
            ) : (
              <div style={{ margin: '1rem 0', overflowY: 'auto', maxHeight: '220px' }}>
                {stores.length === 0 && (
                  <div style={{ textAlign: 'center', marginTop: '1rem' }}>
                    <img src={defaultStoreGrey} style={{ width: '40px' }} />
                    <Typography
                      variant="h6"
                      style={{ fontWeight: '500', lineHeight: '24px', color: 'rgb(255 255 255 / 87%)' }}
                    >
                      Create new store
                    </Typography>
                  </div>
                )}
              </div>
            )}

            {_can(PERM_STORES_ADD_NEW) && (
              <>
                <div className="dividerPrimary" style={{ margin: '1em 0 2px', background: 'rgb(255 255 255 / 16%)' }} />

                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '12px' }}>
                  <Link
                    to={_route('marketplace')}
                    className="adPrimaryButtonColor"
                    style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                  >
                    <AddOutlinedIcon style={{ marginRight: '2px' }} />
                    <span>Add New Store</span>
                  </Link>
                </div>
              </>
            )}
          </div>
        </div>
      </Popover>
    </>
  );
}

export default StoreSwitcher;
